import { styled } from '@mui/material';

// eslint-disable-next-line import/prefer-default-export
export const Cards = styled('div')(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 1fr)',
  gridGap: theme.spacing(3),

  '& > div': {
    padding: theme.spacing(3),
    border: theme.border.default,
    borderRadius: theme.border.radius,

    h2: {
      marginBottom: theme.spacing(2),
    },
  },
}));

